import {
  ADD_SEGMENTS,
  ADD_VARIABLE_GROUP,
  ADD_UPLOAD_FILE,
  BUILD_ACTIVATION,
  BUILD_AUDIENCE,
  CHANGE_BUILD_MODE,
  CHANGE_DESCRIPTION,
  CHANGE_GROUP_OPERATOR,
  CHANGE_GROUP_VARIABLES,
  CHANGE_INSIGHT_META,
  CHANGE_SEGMENT,
  CHANGE_UPLOAD_MODE,
  CHANGE_NAME,
  CHANGE_OPERATOR,
  CREATE_ACTIVATION,
  CREATE_AUDIENCE,
  CREATE_INSIGHT,
  DELETE_ACTIVATION,
  DELETE_AUDIENCE,
  GET_ACTIVATION,
  GET_ACTIVATION_LIST,
  GET_AUDIENCE,
  GET_AUDIENCE_LIST,
  REMOVE_VARIABLE_GROUP,
  RESET_AUDIENCE_STATUS,
  RESET_VARIABLE_GROUP,
  SET_GEO_FENCE,
  SHARE_AUDIENCE,
  SHARE_ACTIVATION,
  UPDATE_ACTIVATION,
  UPDATE_AUDIENCE,
} from "./AudienceActions";
import {
  Activation,
  Audience,
  AudienceSegment,
  AudienceSummary,
  GeoFenceLocation,
  Insight,
  InsightMeta,
  Variable,
} from "@/types";

export type Action =
  | { type: typeof CREATE_AUDIENCE }
  | {
      type: typeof GET_AUDIENCE;
      payload: { audience: Audience | null; built?: boolean };
    }
  | { type: typeof GET_AUDIENCE_LIST; payload: Audience[] }
  | { type: typeof RESET_AUDIENCE_STATUS }
  | {
      type: typeof BUILD_AUDIENCE;
      payload: {
        audience_id?: string;
        audience_geo: string;
        audience_size: AudienceSummary[];
      };
    }
  | {
      type: typeof CREATE_INSIGHT;
      payload: { audience: Audience; insight: Insight };
    }
  | {
      type: typeof CHANGE_DESCRIPTION;
      payload: { segmentNum: number; description: string };
    }
  | { type: typeof CHANGE_INSIGHT_META; payload: InsightMeta[] }
  | {
      type: typeof UPDATE_AUDIENCE;
      payload: { audiences: Audience[]; currentAudience: Audience };
    }
  | { type: typeof DELETE_AUDIENCE; payload: Audience[] }
  | { type: "LOADING" }
  | { type: "ERROR"; payload: string }
  | { type: "RESET" }
  | { type: typeof ADD_VARIABLE_GROUP }
  | { type: typeof REMOVE_VARIABLE_GROUP; payload: number }
  | { type: typeof RESET_VARIABLE_GROUP; payload: number }
  | { type: typeof CHANGE_OPERATOR; payload: string }
  | { type: typeof CHANGE_BUILD_MODE; payload: string }
  | {
      type: typeof CHANGE_GROUP_OPERATOR;
      payload: { id: number; operator: string };
    }
  | {
      type: typeof CHANGE_GROUP_VARIABLES;
      payload: { id: number; variables: Variable[] };
    }
  | { type: typeof ADD_SEGMENTS; payload: AudienceSegment[] }
  | { type: typeof CHANGE_SEGMENT; payload: AudienceSegment }
  | { type: typeof ADD_UPLOAD_FILE; payload: File }
  | { type: typeof CHANGE_UPLOAD_MODE; payload: string }
  | {
      type: typeof CHANGE_NAME;
      payload: {
        audienceId: string;
        audienceName: string;
        projectName: string | null;
      };
    }
  | { type: typeof CREATE_ACTIVATION }
  | { type: typeof GET_ACTIVATION; payload: Activation }
  | { type: typeof GET_ACTIVATION_LIST; payload: Activation[] }
  | { type: typeof UPDATE_ACTIVATION; payload: Activation }
  | { type: typeof DELETE_ACTIVATION; payload: Activation[] }
  | {
      type: typeof BUILD_ACTIVATION;
      payload: { activations: Activation[]; currentActivation: Activation };
    }
  | {
      type: typeof SHARE_AUDIENCE;
      payload: { audienceId: string; userIds: number[] };
    }
  | {
      type: typeof SHARE_ACTIVATION;
      payload: { activationId: string; userIds: number[] };
    }
  | { type: typeof SET_GEO_FENCE; payload: GeoFenceLocation[] };

export interface AudienceState {
  activations: Activation[] | null;
  audiences: Audience[] | null;
  currentActivation: Activation | null;
  currentAudience: Audience | null;
  currentSegment: AudienceSegment | null;
  insight: Insight | null;
  loading: boolean;
  change: boolean;
  built: boolean;
  saved: boolean;
  error: string | null;
}

export const initialState: AudienceState = {
  activations: null,
  audiences: null,
  currentActivation: null,
  currentAudience: null,
  currentSegment: null,
  insight: null,
  loading: false,
  change: false,
  built: false,
  saved: false,
  error: null,
};
